import swal from '@sweetalert/with-react';
import React, { Component } from 'react';
import Loader from '../../components/Loader';
import UserContext from '../../hooks/UserContext';
import {
  EMPTY_DEFINITION,
  normalizeDefinition,
  sameSelection,
} from '../../logic/statisticDefinition';
import DefinitionForm from './DefinitionForm';
import ResultTable from './ResultTable';
import SavedStatistics from './SavedStatistics';
import {
  downloadExcel,
  evaluate,
  failureMessage,
  loadCatalog,
} from './statisticApi';

/**
 * Statistik nach dem Baukasten-Konzept der Jobboerse (CARE-814): Der
 * Redakteur waehlt Kennzahlen und Dimensionen aus dem Katalog des Servers,
 * statt dass jede neue Auswertung programmiert wird. "Statistik Export"
 * bleibt daneben unveraendert bestehen.
 */
class Statistics extends Component {
  static contextType = UserContext;

  constructor(props) {
    super(props);
    this.state = {
      catalog: null,
      catalogFailed: false,
      definition: EMPTY_DEFINITION,
      // Die Eingabefelder sind ungesteuert; ein neuer Schluessel baut das
      // Formular mit einer geladenen Definition neu auf.
      formVersion: 0,
      result: null,
      // Die Definition, fuer die das Ergebnis berechnet wurde.
      resultDefinition: null,
      evaluating: false,
      exporting: false,
    };
  }

  componentDidMount() {
    loadCatalog()
      .then((catalog) => {
        this.setState({
          catalog: {
            Measures: (catalog && catalog.Measures) || [],
            Dimensions: (catalog && catalog.Dimensions) || [],
          },
        });
      })
      .catch((error) => {
        console.error('Statistik-Katalog nicht geladen:', error);
        this.setState({ catalogFailed: true });
      });
  }

  changeDefinition = (definition) => {
    this.setState({ definition: normalizeDefinition(definition) });
  };

  loadDefinition = (definition) => {
    this.setState({
      definition: normalizeDefinition(definition),
      formVersion: this.state.formVersion + 1,
      result: null,
    });
  };

  evaluate = () => {
    const { definition } = this.state;
    this.setState({ evaluating: true });

    evaluate(definition)
      .then((result) => {
        this.setState({
          result,
          resultDefinition: definition,
          evaluating: false,
        });
      })
      .catch((error) => {
        console.error('Statistik nicht ausgewertet:', error);
        // Ein altes Ergebnis wuerde sonst wie die Antwort auf diese Anfrage
        // aussehen.
        this.setState({
          result: null,
          resultDefinition: null,
          evaluating: false,
        });
        swal(
          'Auswertung nicht möglich',
          failureMessage(
            error && error.status,
            error && error.responseText,
            'Die Statistik konnte nicht ausgewertet werden.',
          ),
          'error',
        );
      });
  };

  exportExcel = () => {
    this.setState({ exporting: true });

    downloadExcel(this.state.definition)
      .then(() => {
        this.setState({ exporting: false });
      })
      .catch((error) => {
        console.error('Statistik nicht exportiert:', error);
        this.setState({ exporting: false });
        swal('Export fehlgeschlagen', error.message, 'error');
      });
  };

  renderResult() {
    const { result, resultDefinition, definition } = this.state;
    const stale =
      Boolean(result) && !sameSelection(definition, resultDefinition);

    return (
      <>
        <div aria-live="polite">
          {stale && (
            <p className="Statistics-Note">
              Auswahl geändert – bitte neu auswerten.
            </p>
          )}
        </div>
        {result && !stale && (
          <ResultTable
            result={result}
            catalog={this.state.catalog}
            definition={resultDefinition}
            columnDimensionKey={definition.ColumnDimensionKeys[0]}
          />
        )}
      </>
    );
  }

  renderContent() {
    if (this.state.catalogFailed) {
      return (
        <p className="Statistics-Error" role="alert">
          Der Katalog konnte nicht geladen werden. Bitte laden Sie die Seite
          neu oder versuchen Sie es später erneut.
        </p>
      );
    }

    if (!this.state.catalog) {
      return <Loader />;
    }

    return (
      <>
        <SavedStatistics
          catalog={this.state.catalog}
          definition={this.state.definition}
          isAdmin={Boolean(this.context && this.context.isAdmin)}
          onLoad={this.loadDefinition}
        />
        <DefinitionForm
          key={`statistic-form-${this.state.formVersion}`}
          catalog={this.state.catalog}
          definition={this.state.definition}
          onChange={this.changeDefinition}
          onEvaluate={this.evaluate}
          onExport={this.exportExcel}
          evaluating={this.state.evaluating}
          exporting={this.state.exporting}
        />
        {this.renderResult()}
      </>
    );
  }

  render() {
    return (
      <div>
        <div className="Headerbar sticky">
          <div className="Headerbar-breadcrumbs">
            <h1 className="Statistics-Title">Statistik</h1>
          </div>
        </div>
        <div className="Statistics-content-area">{this.renderContent()}</div>
      </div>
    );
  }
}

export default Statistics;
